import {
  durationInDays,
  removeGQLTypename,
  sortBy,
} from "../../../../../helpers/index";
const moment = require("moment");
const randomize = require("randomatic");
export const updateItemsPax = (allItems) => (data) => {
  const items = [...allItems];

  const { selected, payload } = data;
  const { accommodationSettings, otherTypesSettings, extrasSettings } = payload;

  const updateExtraPax = (extra, settings) => {
    extra.adults = 0;
    extra.children = 0;
    extra.infants = 0;
    extra.qty = settings.qty;
    const settingForExtra = extrasSettings.find((e) => e.id == extra.id);
    if (settingForExtra) {
      extra.adults = settingForExtra.qty;
      extra.qty = settingForExtra.qty;
    } else {
      if (extra.rateBase == "P") {
        if (extra.isChildOnly) {
          extra.children = settings.children;
          extra.qty = settings.children;
        } else if (extra.isChildOnly) {
          extra.infants = settings.infants;
          extra.qty = settings.infants;
        } else {
          extra.adults = settings.adults;
          extra.qty = settings.adults;
        }
      } else {
        extra.adults = settings.adults;
        extra.qty = settings.adults;
      }
    }
  };

  for (const item of items) {
    if (item.serviceName != "TO ZERO PRICES") {
      if (selected.map((s) => s.id).indexOf(item.id) > -1) {
        if (item.serviceType == "ACCOMMODATION" || isIncrementCharge(item)) {
          const accSetting = accommodationSettings.find(
            (s) => s.occupancy == item.stdOccupancy
          );
          if (accommodationSettings) {
            if (isIncrementCharge(item)) {
              const incrementSetting = getSettingForIncrementCharge(
                { ...item },
                accommodationSettings
              );
              if (Number(incrementSetting.qty) > 0) {
                item.adults = incrementSetting.adults;
                item.children = incrementSetting.children;
                item.infants = incrementSetting.infants;
                if (item.serviceType != "MANDATORY_CHARGES") {
                  item.qty = incrementSetting.qty;
                }
              }
            } else {
              if (Number(accSetting.qty) > 0) {
                item.adults = accSetting.adults;
                item.children = accSetting.children;
                item.infants = accSetting.infants;
                if (item.serviceType != "MANDATORY_CHARGES") {
                  item.qty = accSetting.qty;
                }
              }
            }
            for (const extra of item.extras) {
              updateExtraPax(extra, accSetting);
            }
          }
        } else {
          const otherTypeSetting = otherTypesSettings.find(
            (s) => s.type == item.serviceType
          );
          if (otherTypeSetting) {
            item.adults = otherTypeSetting.adults;
            item.children = otherTypeSetting.children;
            item.infants = otherTypeSetting.infants;
            const pax = otherTypeSetting.adults + otherTypeSetting.children;
            //https://tracker.globetrack.ie/issues/10872
            if (item.serviceType != "MANDATORY_CHARGES") {
              item.qty = Math.ceil(pax / item.stdOccupancy);
            }
            for (const extra of item.extras) {
              updateExtraPax(extra, { ...otherTypeSetting, qty: item.qty });
            }
          }
        }
      }
    }
  }
  return items;
};
const isIncrementCharge = (item) => {
  if (item.serviceType != "MANDATORY_CHARGES") {
    return false;
  }
  if (
    ["single", "double", "triple", "quad"].some(
      (str) => item.serviceName.toString().toLowerCase().indexOf(str) > -1
    )
  ) {
    return true;
  }
  return false;
};
const getSettingForIncrementCharge = (item, settings) => {
  const d = {
    adults: item.adults,
    children: item.children,
    infants: item.infants,
    qty: item.qty,
  };
  const occMap = { single: 1, double: 2, triple: 3, quad: 4 };
  const occKey = Object.keys(occMap).find(
    (str) => item.serviceName.toString().toLowerCase().indexOf(str) > -1
  );
  if (occKey) {
    const stdOccupancy = occMap[occKey];
    const setting = settings.find((s) => s.occupancy == stdOccupancy);
    if (setting) {
      return setting;
    } else {
      return d;
    }
  }
  return d;
};
export const updateItemsStatus = (allItems) => (payload) => {
  const items = [...allItems];
  const { selected, status } = payload;
  for (let item of items) {
    if (selected.map((s) => s.id).indexOf(item.id) > -1) {
      item.status = status.name;
      item.statusId = status.id;
    }
    //https://tracker.globetrack.ie/issues/6204
    if (item.extras) {
      for (let extra of item.extras) {
        if (selected.map((s) => s.extraId).indexOf(extra.id) > -1) {
          extra.status = status.name;
          extra.statusId = status.id;
        }
      }
    }
  }
  return items;
};
export const getLog = (item, username) => {
  const {
    rateTypeCode,
    itemBuy,
    itemSell,
    adultBuy,
    adultSell,
    childBuy,
    childSell,
    infantBuy,
    infantSell,
    currencyBuy,
    currencySell,
    currencyBuyExchangeRate,
    currencySellExchangeRate,
  } = item.pricing;
  const supplierCommission = item.supplierCommission;
  return {
    date: moment().format("YYYY-MM-DD"),
    time: moment().format("HH:mm"),
    username,
    rateType: rateTypeCode,
    itemBuy,
    itemSell,
    adultBuy,
    adultSell,
    childBuy,
    childSell,
    infantBuy,
    infantSell,
    currencyBuy,
    currencySell,
    currencyBuyExchangeRate,
    currencySellExchangeRate,
    supplierCommission,
  };
};
export const updateExchangeRates = (allItems) => (payload) => {
  const items = [...allItems];
  const pType = payload.priceType == "cost" ? "Buy" : "Sell";
  for (const item of items) {
    if (payload.items.map((s) => s.id).indexOf(item.id) > -1) {
      //console.log("updating currency for: ", item);
      const currency2update = payload.exchangeRates.find(
        (er) => er.currencyCode == item.pricing[`currency${pType}`]
      );
      if (currency2update) {
        //add log if empty
        if (item.pricing.logs.length == 0) {
          item.pricing.logs.push(getLog(item, payload.username));
        }
        item.customPricing = true;
        item.pricing[`currency${pType}ExchangeRate`] = Number(
          currency2update.exchangeRate
        );
        item.totalCostInBase =
          Number(item.pricing.totalBuy) /
          Number(item.pricing.currencyBuyExchangeRate);
        item.totalSellInBase =
          Number(item.price) / Number(item.pricing.currencySellExchangeRate);
        //add log after change
        //console.log("update fx", item);
        item.pricing.logs.push(getLog(item, payload.username));
        //handle extra
        for (const extra of item.extras) {
          const extraCurrency2update = payload.exchangeRates.find(
            (er) => er.currencyCode == extra[`currency${pType}`]
          );
          if (extraCurrency2update) {
            extra.customPricing = true;
            extra[`currency${pType}ExchangeRate`] = Number(
              extraCurrency2update.exchangeRate
            );
            extra.totalCostInBase =
              Number(extra.totalBuy) / Number(extra.currencyBuyExchangeRate);
            extra.totalSellInBase =
              Number(extra.totalSell) / Number(extra.currencySellExchangeRate);
          }
        }
      }
    }
  }
  return items;
};
export const setZeroSellPrices = (allItems) => (selected) => {
  const items = [...allItems];
  for (let item of items) {
    if (selected.map((s) => s.id).indexOf(item.id) > -1) {
      item.customPricing = true;
      item.price = 0;
      item.pricing.adultSell = 0;
      item.pricing.childSell = 0;
      item.pricing.infantSell = 0;
      item.pricing.itemSell = 0;
      //console.log("setting zero prices for", item);
      for (const extra of item.extras) {
        if (
          selected
            .filter((i) => i.isExtra)
            .map((e) => e.extraId)
            .indexOf(extra.id) > -1
        ) {
          extra.customPricing = true;
          extra.sell = 0;
          extra.totalSell = 0;
        }
      }
    }
  }
  return items;
};
export const adjustPrices = (allItems) => (payload) => {
  const items = [...allItems];
  const { selected, isPercent, amount, isIncrease } = payload;
  const percent = amount / 100;
  const multiplier = isIncrease ? 1 + percent : 1 - percent;
  for (let item of items) {
    if (selected.map((i) => i.id).indexOf(item.id) > -1) {
      item.customPricing = true;
      if (isPercent) {
        item.pricing.adultSell = Number(
          (item.pricing.adultSell * multiplier).toFixed(2)
        );
        item.pricing.childSell = Number(
          (item.pricing.childSell * multiplier).toFixed(2)
        );
        item.pricing.infantSell = Number(
          (item.pricing.infantSell * multiplier).toFixed(2)
        );
        item.pricing.itemSell = Number(
          (item.pricing.itemSell * multiplier).toFixed(2)
        );
        item.price = Number((item.price * multiplier).toFixed(2));
      } else {
        const adjustment = isIncrease ? amount : -amount;
        item.pricing.adultSell = item.pricing.adultSell + adjustment;
        item.pricing.childSell = item.pricing.childSell + adjustment;
        item.pricing.infantSell = item.pricing.infantSell + adjustment;
        item.pricing.itemSell = item.pricing.itemSell + adjustment;
        item.price = calculateItemTotalPrice(item, "Sell");
      }
    }
    if (item.extras) {
      for (const extra of item.extras.filter(
        (e) => parseInt(e.percentPrice) == 0
      )) {
        if (selected.map((i) => i.extraId).indexOf(extra.id) > -1) {
          extra.sell = Number((extra.sell * multiplier).toFixed(2));
          extra.totalSell = Number((extra.totalSell * multiplier).toFixed(2));
          extra.customPricing = true;
        }
      }
    }
  }
  return items;
};

export const refreshPrices = (allItems) => (selected) => {
  const items = [...allItems];
  for (let item of items) {
    if (selected.map((i) => i.id).indexOf(item.id) > -1) {
      //if it's historic price (year shift != 0) we need to refresh the price
      if (item.yearShift != 0) {
        item.id = randomize("Aa0", 32);
        item.customPricing = false;
        item.yearShift = 0;
        item.ratePlan = "";
      }
    }
  }
  return items;
};

export const calculateItemTotalPrice = (item, type) => {
  if (!item || !item.pricing) return 0;

  let total = 0;
  const pricing = item.pricing;

  // Calculate per item or per person price
  if (pricing.itemBased) {
    // Per item calculation
    total = Number(item.qty || 1) * Number(pricing[`item${type}`] || 0);
  } else {
    // Per person calculation
    const adults = Number(item.adults) - (item.supplierComp || 0);
    const children = Number(item.children || 0);
    const infants = Number(item.infants || 0);

    const perAdult = adults * Number(pricing[`adult${type}`] || 0);
    const perChild = children * Number(pricing[`child${type}`] || 0);
    const perInfant = infants * Number(pricing[`infant${type}`] || 0);

    total = perAdult + perChild + perInfant;
  }

  // Apply duration multiplier if day-based
  if (pricing.dayBased) {
    let duration = durationInDays(item.startDate, item.endDate);
    total = total * duration;
  }

  // Apply discounts if provided
  const circuitDiscount = Number(
    pricing[`circuitDiscount${type === "Buy" ? "Cost" : "Sell"}`] || 0
  );
  const regularDiscount = Number(
    pricing[`discount${type === "Buy" ? "Cost" : "Sell"}`] || 0
  );
  const discount = circuitDiscount > 0 ? circuitDiscount : regularDiscount;

  return total - discount;
};

export const toggleCustomPrices = (allItems) => (selected) => {
  const items = [...allItems];
  for (let item of items) {
    if (selected.map((i) => i.id).indexOf(item.id) > -1) {
      item.customPricing = !item.customPricing;
    }
    //handle extras
    for (const extra of item.extras) {
      if (
        selected
          .filter((i) => i.isExtra)
          .map((e) => e.extraId)
          .indexOf(extra.id) > -1
      ) {
        extra.customPricing = !extra.customPricing;
      }
    }
  }

  return items;
};
export const reorderServices = (itStartDate) => (allItems) => {
  const timeRegExp = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/;
  const itStart = moment(itStartDate).startOf("day");
  //get list with proper start date times
  const items = [
    ...allItems.map((item) => {
      // const startTime =
      //   item.serviceType == "ACCOMMODATION"
      //     ? item.remarks && item.remarks.timeFrom
      //       ? item.remarks.timeFrom
      //       : ""
      //     : item.remarks && item.remarks.pickupTime
      //     ? item.remarks.pickupTime
      //     : "";
      const startTime =
        item.remarks && item.remarks.pickupTime ? item.remarks.pickupTime : "";
      const timeIsValid = startTime.match(timeRegExp);
      const itemDate = item.startDate.split("T")
        ? item.startDate.split("T")[0]
        : item.startDate;

      const date = timeIsValid
        ? new Date(`${itemDate} ${startTime}`)
        : new Date(`${itemDate} 00:00`);

      const dayOfStay =
        moment(itemDate).startOf("day").diff(itStart, "days") + 1;

      return { item, date, dayOfStay: dayOfStay * 100 };
    }),
  ];
  //sort and set orderNo
  const serviceInc = 5;
  let orderOnDay = 0;
  const days = [];
  return items.sort(sortBy("date")).map((obj) => {
    if (days.indexOf(obj.dayOfStay) == -1) {
      orderOnDay = 0;
      days.push(obj.dayOfStay);
    }
    orderOnDay += 1;
    obj.item.orderNo = obj.dayOfStay + orderOnDay * serviceInc;
    return { ...obj.item };
  });
};
export const updateRangeByNewStartDate = (range, newStartDate) => {
  const duration = moment(range.end).diff(
    moment(range.start).startOf("day"),
    "days"
  );
  return {
    start: newStartDate,
    end: moment(newStartDate).add(duration, "days").format("YYYY-MM-DD"),
  };
};
export const updateItemsWithNewDateRange = ({ oldRange, newRange, items }) => {
  const offset = moment(newRange.start)
    .startOf("day")
    .diff(moment(oldRange.start).startOf("day"), "days");

  for (const item of items) {
    //#8241
    //treat as new items
    // only if the item is not a mandatory charge
    if (item.serviceType != "MANDATORY_CHARGES") {
      item.id = randomize("Aa0", 32);
    }

    item.startDate = moment(item.startDate)
      .startOf("day")
      .add(offset, "days")
      .format("YYYY-MM-DD");

    item.endDate = moment(item.endDate)
      .startOf("day")
      .add(offset, "days")
      .format("YYYY-MM-DD");
    if (item.extras && item.extras.length > 0) {
      for (const extra of item.extras) {
        extra.startDate = moment(extra.startDate)
          .startOf("day")
          .add(offset, "days")
          .format("YYYY-MM-DD");

        extra.endDate = moment(extra.endDate)
          .startOf("day")
          .add(offset, "days")
          .format("YYYY-MM-DD");
      }
    }
  }
  return items;
};
export const updateTransportPrice = (item, rateType) => {
  //console.log("update transport price", item.serviceType != "TRANSPORT");
  if (item.serviceType != "TRANSPORT") {
    return item;
  }
  if (
    item.customPricing &&
    item.remarks.pickupTime != "" &&
    item.remarks.dropoffTime != ""
  ) {
    let total = 0;
    let duration = durationInDays(item.startDate, item.endDate);
    //Looks like it's actually in "nights" so we need add 1 day to the duration https://tracker.globetrack.ie/issues/10228
    duration = duration + 1;
    if (rateType.includePax) {
      total =
        item.adults * Number(item.pricing.adultSell) +
        Number(item.children) * Number(item.pricing.childSell) +
        Number(item.infants) * Number(item.pricing.infantSell);
    } else if (rateType.includeQuantity) {
      total = item.qty * Number(item.pricing.itemSell);
    }
    const start = parseInt(item.remarks.pickupTime.replace(":", ""));
    const end = parseInt(item.remarks.dropoffTime.replace(":", ""));
    // console.log("duration in days", duration);
    // console.log("start", start, "end", end);
    // console.log("duration", duration);
    if (end <= start) {
      duration--;
    }
    total = total * duration;
    item.price = total;
    //set new id to recalc custom pricing
    item.id = randomize("Aa0", 32);

    //console.log("update transport price", item, total, duration);
  }

  return item;
};
export const fromItineryItem = (node) => {
  const item = node.node;
  const { __typename, ...source } = item.source;
  const pricing = { ...item.pricing };
  const remarks = { ...item.remarks };
  const extras = item.extras.map((e) => ({
    id: e.id,
    uid: e.uid, //https://tracker.globetrack.ie/issues/8740 wtfff? why uid was not present in those items?
    //id: e.id.split("_")[1],
    name: e.name,
    startDate: e.startDate,
    endDate: e.endDate,
    qty: e.qty, //extraDisplayQty(e),
    totalBuy: e.totalBuy,
    totalSell: e.totalSell,
    currencySell: e.currencySell,
    currencyBuy: e.currencyBuy,
    isChildOnly: e.isChildOnly,
    isInfantOnly: e.isInfantOnly,
    isMandatory: e.isMandatory,
    includeCommission: e.includeCommission,
    rateBase: e.rateBase,
    adults: e.adults,
    children: e.children,
    infants: e.infants,
    cost: e.cost,
    sell: e.sell,
    rateTypeCode: e.rateTypeCode,
    percentPrice: e.percentPrice,
    customPricing: e.customPricing,
    currencySellExchangeRate: e.currencySellExchangeRate,
    currencyBuyExchangeRate: e.currencyBuyExchangeRate,
    isHidden: e.isHidden,
    status: e.status,
    statusId: e.statusId,
    totalCostInBase: e.totalCostInBase,
    totalSellInBase: e.totalSellInBase,
    discount: e.discount,
    discountCost: e.discountCost,
    discountSell: e.discountSell,
    toms: e.toms,
    remarks: removeGQLTypename(e.remarks),
    orderNo: e.orderNo,
  }));
  delete pricing.__typename;
  pricing.logs = pricing.logs ? pricing.logs.map(removeGQLTypename) : [];
  return {
    id: item.id,
    serviceId: item.service ? item.service.id : "",
    supplierId: item.supplier ? item.supplier.id : "",
    serviceName: item.serviceName,
    serviceAltName: item.service ? item.service.altName : "",
    stdOccupancy: item.service ? Number(item.service.stdOccupancy) : 1,
    supplierName: item.supplierName,
    supplierDestination: item.supplierDestination,
    headOffice:
      item.supplier && item.supplier.headOffice
        ? item.supplier.headOffice.name
        : "",
    startDate: item.startDate,
    endDate: item.endDate,
    price: item.totalPrice,
    totalCostInBase: item.totalCostInBase,
    totalSellInBase: item.totalSellInBase,
    margin: item.margin,
    markup: item.markup,
    status: item.status,
    statusId: item.statusId,
    adults: item.pax.adults,
    children: item.pax.children,
    infants: item.pax.infants,
    qty: item.qty,
    rateTypeCode: item.rateTypeCode,
    taxCode: item.taxCode ? item.taxCode : "",
    ratePlan: item.ratePlan ? item.ratePlan : "",
    serviceType: item.serviceTypeName,
    orderNo: item.orderNo,
    isIncluded: item.isIncluded,
    isOptional: item.isOptional,
    isHidden: item.isHidden,
    includeCommission: item.includeCommission,
    tags: item.tags,
    hasApprovedPurchaseInvoice: item.hasApprovedPurchaseInvoice,
    hasPurchaseInvoice: item.hasPurchaseInvoice,
    allocation:
      pricing.pricingDays && pricing.pricingDays[0]
        ? pricing.pricingDays[0].allocation
        : "",
    selected: false,
    source: {
      id: source.sourceId,
      name: source.name,
      confirmationRef: source.confirmationRef,
    },
    customPricing: item.customPricing,
    businessModel: item.businessModel,
    businessModelName: item.businessModelName,
    supplierCommission: item.supplierCommission,
    supplierComp: item.supplierComp ? item.supplierComp : 0,
    passComp: item.passComp ? item.passComp : 0,
    toms: item.toms,
    yearShift:
      Number(item.yearShift) > 0
        ? Number(item.yearShift) * -1
        : Number(item.yearShift),
    boardBasis: item.boardBasis,
    isHistoricalRate: item.isHistoricalRate,
    pricing,
    extras,
    remarks,
  };
};



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/builder/tools/helpers.js